import { ref } from "vue";

const STORAGE_KEY = "sign_in_hero_index";
export const SIGN_IN_HERO_COUNT = 10;

function pickHeroIndex(): number {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    const parsed = stored === null ? NaN : Number(stored);
    if (Number.isInteger(parsed) && parsed >= 0 && parsed < SIGN_IN_HERO_COUNT) return parsed;

    const index = Math.floor(Math.random() * SIGN_IN_HERO_COUNT);
    sessionStorage.setItem(STORAGE_KEY, String(index));
    return index;
  } catch {
    return Math.floor(Math.random() * SIGN_IN_HERO_COUNT);
  }
}

const signInHeroIndex = ref(pickHeroIndex());

export function useSignInHero() {
  return { signInHeroIndex };
}
